import { render, staticRenderFns } from "./quiz-instruction.html?vue&type=template&id=242622ca&scoped=true&external"
import script from "./quiz-instruction.js?vue&type=script&lang=js&external"
export * from "./quiz-instruction.js?vue&type=script&lang=js&external"
import style0 from "./quiz-instruction.css?vue&type=style&index=0&id=242622ca&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242622ca",
  null
  
)

export default component.exports